import { RootState } from "app/store";
import { setLayerVisibility } from "features/krpano/details-slice";
import { CustomGroupTypes } from "krpano";

// Props for components - START
export interface LayerGroupProps {
  type: Parameters<typeof setLayerVisibility>[0][number]["type"];
}
export interface LayerProps {
  layerName: RootState["krpano"]["layers"][LayerProps["type"]][number]["name"];
  type: LayerGroupProps["type"];
  targetIndex?: Parameters<typeof setLayerVisibility>[0][number]["targetIndex"];
  visible: RootState["krpano"]["layers"][LayerProps["type"]][number]["visible"];
}
// Props for components - END

// API - START
export type LayerGeometryType = "line" | "point" | "polygon";
export type GetLayerParams = {
  currentFieldID: NonNullable<
    RootState["panorama"]["currentFieldDetails"]
  >["fid"];
  panoramaGuid: NonNullable<RootState["panorama"]["guid"]>;
};
export type GetLayerResponse =
  // The expected response shape
  | {
      GroupName: "Features" | string;
      Layers: {
        LayerName: string;
        Entries: {
          GeometryType: LayerGeometryType;
          Points: {
            ath: number;
            atv: number;
          }[];
          Tags: Record<string, string>;
        }[];
      }[];
    }
  // Edge-case where there are no layers at all, an empty object is returned
  | {};

export type GetLayerParsedResponse = RootState["krpano"]["layers"]["features"];
// API - END

// Helpers - START
/**
 * Parse the group name into a more user-friendly format
 */
export const getGroupName = (group: keyof RootState["krpano"]["layers"]) => {
  switch (group) {
    // Basic Layers in this group
    case "fields":
      return "Fields";
    // Overpass API Layers in this group
    case "features":
      return "Features";
    default:
      // console.warn("Missing group name parser for:", group);
      return group;
  }
};

/**
 * Parse the layer name into a more user-friendly format
 */
export const getLayerName = (layer: CustomGroupTypes | string) => {
  switch (layer) {
    // Basic Layers
    case "boundary_line":
      return "Field Boundary";
    case "field_marker":
      return "Field Markers";
    case "poi_spot":
      return "Scout Points";
    // Overpass API - Feature Layers
    case "Transport":
      return "Transport";
    case "Land":
      return "Land";
    case "Sports":
      return "Sports";
    case "Power":
      return "Power";
    case "Aeroways":
      return "Aeroways";
    case "Infrastructure":
      return "Infrastructure";
    default:
      // console.warn("Missing layer name parser for:", layer);
      return layer;
  }
};
// Helpers - END
